module.exports = __webpack_public_path__ + "static/img/taiheTop.7bf12a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/taiheTop.png
// module id = cLfm
// module chunks = 2